import { Injectable } from '@angular/core';


/**
 * Servicio para encriptar peticiones y mantener comunicacion segura con el back (AES-GCM)
 */
@Injectable()
export class CryptoService {
  constructor() {     
}

/**
 * Encripta la data de las peticiones
 * @param textplain 
 * @param keyIn 
 * @param ivIn 
 */
  async Encriptar(textplain, keyIn, ivIn): Promise<string> {
    const encoder = new TextEncoder();
    const keyBytes = encoder.encode(keyIn);
    const ivBytes = encoder.encode(ivIn);

    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['encrypt']
    );

    const encrypted = await crypto.subtle.encrypt(
      { name: 'AES-GCM', iv: ivBytes, tagLength: 128 },
      cryptoKey,
      encoder.encode(textplain.toString())
    );

    return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
  }

  /**
   * Desencripta la data de las peticiones
   * @param textplain 
   * @param keyIn 
   * @param ivIn 
   */
  async Desencriptar(textplain, keyIn, ivIn): Promise<string> {
    const encoder = new TextEncoder();
    const decoder = new TextDecoder();
    const keyBytes = encoder.encode(keyIn);
    const ivBytes = encoder.encode(ivIn);

    const encryptedBytes = Uint8Array.from(atob(textplain), c => c.charCodeAt(0));

    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      keyBytes,
      { name: 'AES-GCM' },
      false,
      ['decrypt']
    );

    const decrypted = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv: ivBytes, tagLength: 128 },
      cryptoKey,
      encryptedBytes
    );

    return decoder.decode(decrypted);
  }

}